// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-radio-form-component {
  font-size: 1rem;
  display: flex;
  width: 100%;
  justify-content: start;
  align-items: start;
}
.input-radio-form-component input {
  width: 1.8rem;
  height: 1.8rem;
  border: 1px solid blue;
}
.input-radio-form-component input:hover {
  cursor: pointer;
}
.input-radio-form-component label {
  font-size: 1.4rem;
  height: 100%;
  margin-left: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/fields/RadioButtonForm/index.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;AACF;AACE;EACE,aAAA;EACA,cAAA;EACA,sBAAA;AACJ;AACI;EACE,eAAA;AACN;AAGE;EACE,iBAAA;EACA,YAAA;EACA,iBAAA;AADJ","sourcesContent":[".input-radio-form-component {\n  font-size: 1rem;\n  display: flex;\n  width: 100%;\n  justify-content: start;\n  align-items: start;\n\n  input {\n    width: 1.8rem;\n    height: 1.8rem;\n    border: 1px solid blue;\n\n    &:hover {\n      cursor: pointer;\n    }\n  }\n\n  label {\n    font-size: 1.4rem;\n    height: 100%;\n    margin-left: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
